export { default } from "./InputText";
